module.exports = __webpack_public_path__ + "static/media/event_management_mo.6592f574.png";